const enums = {
  LOGS: {
    STATUS: {
      FETCHING: "fetching"
    }
  },

  QUARANTINES: {
    STATUS: {
      FETCHING: "fetching"
    }
  },

  ARCHIVES: {
    STATUS: {
      FETCHING: "fetching"
    }
  },

  PAGINATE: {
    TYPES: {
      CONVERSATION: "conversation",
      MESSAGE: "message"
    }
  },

  DRAFT: {
    STATUS: {
      DELETING: "deleting",
      IDLE: "idle"
    }
  },

  COMPOSE: {
    MODE: {
      DEFAULT: "default",
      REPLY: "reply",
      REPLY_ALL: "replyAll",
      DRAFT: "draft",
      FORWARD: "forward",
      FORWARD_AS_ATTACHMENT: "forward_as_attachment",
      EDIT_AS_NEW: "edit_as_new"
    }
  }
};

export default enums;
